import { InstrumentT } from 'types';

export const sortInstruments = (instruments: InstrumentT[]) => {
  return instruments.sort((a: InstrumentT) => {
    if (a.instrument_id.includes('AVAX')) {
      return -1;
    }
    return 0;
  });
};

export const getDefaultInstrument = (instruments: InstrumentT[]) => {
  const localStore = localStorage.getItem('store') || '{}';
  const defaultInstrument = JSON.parse(localStore)?.currentInstrument;
  const selectedInstrument = instruments.find(i => i.instrument_id === defaultInstrument) || instruments[0];
  return selectedInstrument;
};
